<template>
  <div>
    <div>Unsupported Event Type</div>
  </div>
</template>
